import { render, staticRenderFns } from "./infinite-scroll-vertical.vue?vue&type=template&id=1c632ed4&scoped=true&"
import script from "./infinite-scroll-vertical.vue?vue&type=script&lang=js&"
export * from "./infinite-scroll-vertical.vue?vue&type=script&lang=js&"
import style0 from "./infinite-scroll-vertical.vue?vue&type=style&index=0&id=1c632ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c632ed4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
